import { render, staticRenderFns } from "./PostCreation_Image.vue?vue&type=template&id=e498d0ba&"
import script from "./PostCreation_Image.vue?vue&type=script&lang=js&"
export * from "./PostCreation_Image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports